import http from "../http-common";

class SubjectService {
  createSubject(data) {
    return http.post(`/api/subjects`, data);
  }
  getSubjects() {
    return http.get(`/api/subjects`);
  }
  AssignSecondProctor(year,term,exam_type) {
    return http.get(`/api/subjects/assign`+`?year=${year}&term=${term}&exam_type=${exam_type}`);
  }
  getAssignsDisplay(data) {
    return http.get(`/api/subjects/getGenerate`+'?year=' + data.year + '&term=' + data.term + '&exam_type=' + data.exam_type + '&exam_date=' + data.exam_date + '&faculty_id=' + data.faculty_id + '&course_id=' + data.course_id+ '&subject=' + data.subject + '&instructor=' + data.instructor);
  }
  EditSecondProctor(data) {
    return http.get(`/api/subjects/editSecond`+`?year=${data.year}&term=${data.term}&exam_type=${data.exam_type}&subject_id=${data.subject_id}`);
  }
  GeneratePDF(year,term,exam_type) {
    return http.get(`/exportpdf`+`?year=${year}&term=${term}&exam_type=${exam_type}`);
  }
  getSubjectsDisplay(data) {
    return http.get(`/api/subjects/getByFormat`+'?year=' + data.year + '&term=' + data.term + '&exam_type=' + data.exam_type + '&exam_date=' + data.exam_date + '&faculty_id=' + data.faculty_id + '&course_id=' + data.course_id+ '&subject=' + data.subject + '&instructor=' + data.instructor);
  }
  updateSubject(id, data) {
    return http.put(`/api/subjects/${id}`, data);
  }
}

export default new SubjectService();